export enum FeatureFlagId {
  USE_PORTAL_CHAT = 'USE_PORTAL_CHAT',
  SHOW_MESSAGES_POPUP = 'SHOW_MESSAGES_POPUP',
  USE_NEW_STATISTICS = 'USE_NEW_STATISTICS',
}

export type FeatureFlags = Record<string, string>
